import { render, staticRenderFns } from "./ColumnCustomer.vue?vue&type=template&id=661b85cf&"
import script from "./ColumnCustomer.vue?vue&type=script&lang=ts&"
export * from "./ColumnCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports